import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faArchive,
  faBars,
  faBox,
  faCancel,
  faCheck,
  faCopy,
  faEdit,
  faEye,
  faFile,
  faFileLines,
  faMinus,
  faPen,
  faPlus,
  faQuestionCircle,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faTrashAlt,
  faUser,
  faUserLock,
  faUserPlus,
  faUsers,
  faCaretDown,
  faCaretRight,
  faTruck,
  faClipboardList,
  faList,
  faExpand,
  faX,
  faPrint,
  faHistory,
  faLongArrowRight,
  faWarehouse,
  faHandsHelping
} from '@fortawesome/free-solid-svg-icons';

export function configureFontAwesome(): void {
  library.add(
    faSearch,
    faTrashAlt,
    faEdit,
    faSignOutAlt,
    faCheck,
    faBars,
    faCopy,
    faSpinner,
    faUserPlus,
    faArchive,
    faUsers,
    faMinus,
    faPlus,
    faPen,
    faUser,
    faQuestionCircle,
    faFile,
    faFileLines,
    faCancel,
    faUserLock,
    faCaretDown,
    faCaretRight,
    faTruck,
    faEye,
    faClipboardList,
    faBox,
    faList,
    faExpand,
    faX,
    faPrint,
    faHistory,
    faLongArrowRight,
    faWarehouse,
    faHandsHelping
  );
}
